<template>
  <div id="mobile_classify" v-title :data-title="`${this.$headToUpperCase} Game Types ——${gameType}`">
    <div v-if="contentType" class="content">
      <MobileLogo whereFrom="3" portal="mobile_tab"></MobileLogo>
      <div v-if="clientWidth < 550.9">
        <div class="eZzVdA" :class="index == 0 ? eZzVdABef : null" v-for="(item,index) in gameList" :key="index">
          <div :class="typeAdv && index == 0
           ? 'cTVRlj3' : 'cTVRlj'">
            <div class="game-name" v-if="index == 0" style="grid-area: ibx">
              <h1>{{ gameType }}</h1>
            </div>
            <div class="adv" v-if="index == 0" v-show="typeAdv" style="grid-area: adv">
              <ins class="adsbygoogle"
                   id="typeAdv"
                   style="display:block;min-height: 314px"
                   data-ad-client="ca-pub-2075998924432436"
                   :data-ad-slot="slot"
                   data-ad-format="true"
                   data-full-width-responsive="true"></ins>
            </div>
            <a
                v-for="(items,indexs) in item"
                :key="indexs" :href="'/M/details/'+items.Name.replace(/\s+/g, '')+'?gameId='+items.gameId+($route.query.channel ? ('&channel='+$route.query.channel): '')"
                class="sc-wr3rvk-0 cASSfo sc-963fcq-2 cOWZsC sc-al88rd-1 global-cq"
                :style="(indexs == 0 && item.length >4) || (indexs == 6 && item.length > 9) ? {gridArea: 'bigIp' + indexs}: null"
                @click="iconClick(items)">
              <img v-if="(indexs == 0 && item.length >4) || (indexs == 6 && item.length > 9)" v-lazy="items.iconUrl" alt="" width="204px" height="204px" class="eoBBYj">
              <img v-else v-lazy="items.iconUrl" alt="" width="94px" height="94px" class="eoBBYj">
              <span class="sc-963fcq-0 esaxGV global-cq-title">{{items.Name}}</span>
            </a>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="eZzVdA" :class="eZzVdABef">
          <div :class="typeAdv ? 'cTVRlj3' : 'cTVRlj'">
            <div class="game-name" style="grid-area: ibx">
              <h1>{{ gameType }}</h1>
            </div>
            <div class="adv" v-show="typeAdv" style="grid-area: adv">
              <ins class="adsbygoogle"
                   id="typeAdv"
                   style="display:block;min-height: 314px"
                   :data-ad-client="caPub"
                   :data-ad-slot="slot"
                   data-ad-format="true"
                   data-full-width-responsive="true"></ins>
            </div>
            <a v-for="(item,index) in gameList" :key="index" :href="'/M/details/'+item.Name.replace(/\s+/g, '')+'?gameId='+item.gameId+($route.query.channel ? ('&channel='+$route.query.channel): '')" class="sc-wr3rvk-0 cASSfo sc-963fcq-2 cOWZsC sc-al88rd-1 global-cq" :style="(index == 0 && gameList.length > 5) || (index == 1 && gameList.length > 5) ? {gridArea: 'bigIp' + index}: null" @click="iconClick(item)">
              <img v-if="(index == 0 && gameList.length > 5) || (index == 1 && gameList.length > 5)" v-lazy="item.iconUrl" alt="" width="204px" height="204px" class="eoBBYj">
              <img v-else v-lazy="item.iconUrl" alt="" width="94px" height="94px" class="eoBBYj">
              <span class="sc-963fcq-0 esaxGV global-cq-title">{{item.Name}}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="eZzVdA2" v-if="!gameList.length">
        <div class="cTVRlj2">
          <div class="game-name" style="grid-area: ibx">
            <h1>{{ gameType }}</h1>
          </div>
        </div>
      </div>
    </div>
    <div v-if="contentType" class="bottom">
      <ClassList :gameTypeList="recommend" :styleType="true" fromWhere="1"></ClassList>
      <BottomList whereFrom="3"></BottomList>
      <div class="bottom-text">
        <nav class="about">
          <ul>
            <li><a href="/">Games</a></li>
            <li>{{gameType}} games</li>
          </ul>
        </nav>
        <div class="title"><h2>{{gameType.slice(0,1).toUpperCase() + gameType.slice(1).toLowerCase()}} Games</h2></div>
        <div v-if="gameType == 'SHOOTING'">
          <p>Expensive video game consoles aren’t the only place to play marksmanship games. Our collection of shooting games are all free to play and available right now, on your computer. Play as a variety of marksmen in tons of environments, sneaking through levels and firing at any enemies in your path. Create classes with all kinds of different guns. Play as a futuristic assassin with ultra-modern weapons or go back in time and re-live the Doom game series. In our shooting challenges, you can holster your weapon as a solo player or unleash ammo as a member of a multiplayer task force. The possibilities are endless.</p>
          <p>Play now our online Shooting Games for free on your PC. You can play the Shooting Games in your browser without having to download them. Most of our games can also be played on a mobile phone or tablet. Have fun playing the best shooters here on {{$originCopyWriting}}!</p>
          <h3>How to play Shooting Games?</h3>
          <p>All our shooting can be controlled with keyboard and mouse. First look into the description of the games, often you can find the controls there. Else these are the most commonly used controls for the PC:</p>
          <ul>
            <li>WASD - Move Around</li>
            <li>Mouse - Aim</li>
            <li>Left Mouse Click - Shoot</li>
            <li>Right Mouse Click - Zoom In</li>
            <li>Spacebar - Jump</li>
            <li>Shift - Sprint</li>
            <li>R - Reload</li>
          </ul>
          <p>Some of the shooting games can also be played on a mobile phone or tablet. Then you control everything with your touchscreen.</p>
        </div>
        <div v-if="gameType == 'CAR'">
          <p>Whether you enjoy race cars, dune buggies, or motorcycles, we have the perfect car challenge for you. Go from 0 to 60 mph in mere seconds in one of our racing challenges, and try to set a new speed record. Or, choose an off-road vehicle and traverse over mountains, junkyards, and other exotic terrains. Even go through hundreds of options and customize your very own vehicle in our car games! After creating the ideal ride, take your racer on the road and challenge tough opponents. A full selection of go kart and parking challenges are included, too!</p>
          <p>Some of our free car games can even be played in 3D! The games are easy to control and fun for all kinds of players. Play all of our car games online on your PC and use your keyboard to accelerate, brake, and steer your vehicle. Some games allow you to modify the environment and balance your vehicle with a simple press of the arrow keys. Some of our car games can also be played on the mobile phone or tablet and are controlled with the touchscreen. Hours and hours of countless fun are at your fingertips, with a little-to-no learning curve! Wield the power of a gigantic monster truck or race across tracks at 200+ mph in an exotic sport car. For a strategic challenge, try squeezing your car into a tight spot in a parking game variant!</p>
        </div>
        <div v-if="gameType == 'BALL'">
          <p>Compete against the best athletes in the world, and win grueling championship tournaments! Our ball games include every type of incredible sport, including football, basketball, and baseball. Now, you have the chance to play like Pelé in the World Cup! Or, pretend you're Michael Jordan, and score against the best NBA teams. Our baseball challenges include backyard games and home run derby competitions. Instead of simply watching sports on TV, you should play them right here!</p>
          <p>Our ball games will make you feel like a real superstar. On the gridiron, you can throw touchdown passes like a real NFL quarterback. As a soccer all-star, you have the ability to score free kicks and help your goalkeeper make amazing saves. Every game in our collection teaches you how to kick, pass, toss, and shoot like Hall of Fame athletes. Win the playoffs to take home the gold medal!</p>
        </div>
        <div v-if="gameType == 'GIRLS'">
          <p>Our vast collection of girl games is sure to entertain you. You can play any type of game, from simple dress-up to advanced dance competitions. Control cute characters and admirable women. Show off your extreme gaming skills, or relax with fashion-based games. For a romantic adventure, pick a cute date, and fall in love! Create outfits for celebrities, design dresses for dolls, or apply cute makeup. Fulfill your wildest shopping dreams without spending a penny.</p>
          <p>Our games for girls collection features all sorts of licensed dolls and characters. You can play games featuring Barbie and Bratz dolls, and even play with replicas of your own toys! Bring your toy chest to life with highly authentic, virtual characters. For a classic, girly challenge, try one of our adorable Holly Hobbie or Hello Kitty adventures. Try playing with cats and dogs, and take care of your own pet! From Sue to Winx to Nick Jr.'s Dora the Explorer, our playful collection will make every girl happy.</p>
        </div>
        <div v-if="gameType == 'CASUAL'">
          <p>Casual games are usually the most relaxing and enjoyable games to kill time. They usually offer some easy but not so hard challenges, so you can relax and enjoy a relaxing time.</p>
          <p>Our casual games are rich in variety and full of creativity. There are fun and stress-relieving elimination games, relaxing and enjoyable bubble shooters, and many agility games that test your reflexes. Graffiti, puzzles, puzzles, dress-up, etc. are all here, you won't be bored.</p>
        </div>
        <div v-if="gameType == 'PUZZLE'">
          <p>Stunning graphics and smooth action are included in all of our puzzle games. Your strategic skills and puzzle-solving abilities will be put to the test, as you try to complete one of thousands of different challenges! In our challenges, you can build bridges, match moving shapes, and define routes to win. Solve 3D Rubik’s Cubes, challenge the computer in Tic-Tac-Toe, and cause chain reactions in our collection! Stimulate your brain today, and dive into a puzzling challenge. We have Orbox, rotation games, and much more waiting for you!</p>
          <p>A mouse and keyboard are all you need to solve our many exciting puzzles. Our collection includes adventures for every type of player! You can enjoy arcade-style 2D graphics or neon-fused 3D artwork in our puzzle games. Work with Rube Goldberg devices, solve engineering mysteries, and put your problem-solving skills to the test. After diving into our mind-bending collection, you'll never be bored ever again!</p>
        </div>
        <div v-if="gameType == 'ACTION'">
          <h4>For the fighter, a thirst for battle!</h4>
          <p>Satisfying guns, explosive gameplay and a randomized weapon system - that's Action Games! No matter if you're playing Mini Royale, Repuls.io or any other Action Game - the epic journey awaits you in this unique genre.</p>
          <p>Action Games brings mobile games where hand-to-hand combat is king. Featuring games that will get your blood pumping with an exciting mix of hack-and-slash, war and action themes, you'll never be at a loss for the next saga.</p>
          <p>These top-rated action games are designed to be challenging. Whether you're looking for an adrenaline rush or a casual arcade game, you'll find something that fits your style.</p>
          <p>Hundreds of action games are out there, and we've covered all of the best ones for mobile. Some action games are multiplayer, while others have huge maps you have to explore. Some are puzzle based, and others include epic graphics and cool props. Action games may be 3D based or 2D, but they will always give you an adrenaline rush.</p>
          <p>Action Games are great for anyone that likes to act cool by engaging in fast paced battles, using melee and ranged attacks to defeat their opponents. Collect items on the battlefield, upgrade your weapons and go for headshots and critical hits to take down your foes.</p>
        </div>
        <div v-if="gameType == 'RACING'">
          <p>Ride in all types of different vehicles in our racing games! Take the traditional route, and drive a sports car on a racetrack. Or, weave through traffic on a busy city course! You can hit the streets with your friends, or compete with other racers online. For a slower challenge, pedal your way through a bicycle racing game. Race in tons of different environments! After conquering courses on land, take a boat into the water! Learn how to master any mode of transportation, and always go for the gold!</p>
          <p>Navigate racetracks in our collection with ease! Peel out from the start, skid around turns, and speed through straightaways. Many of our racing games put you in the driver's seat, so you can look right through the dashboard! Enjoy realistic cockpit graphics, panoramic views, and responsive controls. Use mirrors to get a better angle, and hurry to the finish! Drift behind your opponents, catch a tailwind, and glide to the front of the pack. Finish in first place in a dirt race, on water, or through the sky!</p>
        </div>
        <div v-if="gameType == 'PARKOUR'">
          <p>Run, flip, and wall-jump through amazing urban courses in our parkour games! Based on military training through obstacle courses, the art of parkour requires total body control. You will face all sorts of barriers in each course. Figure out the best way to move without stopping, and get past every obstacle! Learn how to move like the best free-runners in the world, and win the championship!</p>
          <p>Our parkour games are filled with realistic and cartoon challenges! Play as Faith from Mirror's Edge, and go on a dangerous journey through high-security areas. Run across rooftops, flip over gaps, and sprint to survive! Each athlete is a master of free-running. Your job is to take control and complete entire courses without getting caught. Train with the best competitors from American Ninja Warrior!</p>
        </div>
        <div v-if="gameType == '3D'">
          <p>Our 3D games are highly addictive and fun for all players. If you enjoy great graphics and fast action, you’ll love our 3-dimensional games! You can modify star constellations, create your own images, and even construct lifelike pictures. Our collection features hundreds of challenging levels and images. Re-create realistic star patterns, unscrambled jumbled images, and earn thousands of points! Solve each puzzle quickly enough, and you can advance to the next level and earn an admirably high score!</p>
          <p>You’ll learn to play our 3D games in a matter of seconds; just use your mouse and manipulate the image into the correct pattern. Our 3-dimensional games feature in-game tutorials, guiding you step-by-step through the first few levels. After this mini-training session, you’ll be on your way to becoming an expert! Choose your favorite adventure, which features several different environment options; play in outer space or in an abstract video game land! Take delight in the smooth gameplay and vibrant graphics in our collection!</p>
        </div>
        <div v-if="gameType == 'ADVENTURE'">
          <p>Our collecting of adventure gaming is perfect for highly skilled and newbie players alike. Enjoy simple Point 'n Click challenges, try wild, action-packed games, or play full-scale RPGs! Travel from your country to other continents, and even venture into outer space! With thousands of adventure games available, you can partake in addictive journeys for countless hours! Ride rollercoasters, don't get caught, and battle with dangerous pirates! Play modded, computer versions of your favorite console games, or try totally unique Flash games!</p>
          <p>Our adventure collection includes games from dozens of different genres. Music fans can learn to play to instruments and create songs, while movie buffs can reenact scenes from their favorite films! Play the role of business owner, and run a bustling restaurant in a management-style game. Choose a character in each challenge to represent you or one of your heroes.  Solve mysteries in point 'n click challenges, and compete with players around the world. Make key decisions, and experience a brand new journey every time in our adventure games!</p>
        </div>
        <div v-if="gameType == 'ARCADE'">
          <p>Our collection is an amalgam of the greatest arcade games ever made. We have older and brand new machines, from original Pong to 3D air hockey! In our challenging levels, you’ll experience exciting action and captivating gameplay. Play modern variations of Space Invaders and Bomberman, complete with authentic game sounds and graphics. Or, play updated Nintendo and Sega games, including Mario and Sonic the Hedgehog. All of your arcade desires are waiting to be fulfilled.</p>
          <p>Our collection also includes less conventional games, which are just as entertaining. Play Final Fantasy modifications, WALL-E themed games, and much more. Regardless of the adventure you choose, our arcade games feature easy-to-learn controls. Use your keyboard and mouse to shoot lasers, move characters, and hop across giant gaps. Earn points, virtual money, and compete against others in our 8-bit challenges. Start playing today and become a master of the virtual arcade.</p>
        </div>
        <div v-if="gameType == 'SPORTS'">
          <p>Athletes, fans, and all-star gamers will love our collection of sports games! You can play 8- or 9-ball billiards against the computer, box with your friends, and ride galloping horses. Play team games like soccer and baseball, and try to win league tournaments. Relax with a skilled, leisure game, or head into extreme territory. Play a whole slew of winter sports, including skiing, sledding, and downhill toboggan challenges. Go head-to-head against difficult AI, or compete with challenging, athletic players around the world.</p>
          <p>Compete on land, in the water, or high in the sky! Play all types of sports games, from traditional football to extreme base-jumping. Control your player's power in each game, and use it to defeat your opponents! Throw punches, perform tackles, and leap through the air with aggression. Perform tricks with a trampoline master, or backflip over snowy ramps. Practice using effective teamwork in multiplayer challenges, and work on your own skills in head-to-head challenges. Win individual games to dominate online tournaments.</p>
        </div>
        <h3>What are the best free Shooting Games online?</h3>
        <ol>
          <li v-for="(item,index) in allGameList.slice(0,10)" :key="index">
            <a :href="'/M/details/'+item.Name.replace(/\s+/g, '') + '?gameId='+item.gameId+($route.query.channel ? ('&channel='+$route.query.channel): '')" @click="iconClick(item)">
              {{item.Name}}
            </a>
          </li>
        </ol>
        <h3>What are the most popular Shooting Games for the mobile phone or tablet?</h3>
        <ol>
          <li v-for="(item,index) in allGameList.slice(0,5)" :key="index">
            <a :href="'/M/details/'+item.Name.replace(/\s+/g, '') + '?gameId='+item.gameId+($route.query.channel ? ('&channel='+$route.query.channel): '')" @click="iconClick(item)">
              {{item.Name}}
            </a>
          </li>
        </ol>
      </div>
    </div>
    <div style="display: contents" v-if="smegmaType">
      <div class="AFSJx dgmlwU" style="background-color: #ffffff">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import MobileLogo from '@/components/MobileLogo.vue';
import BottomList from "@/components/MobileTerminal/MobileHome/BottomList";
import ClassList from "@/components/MobileTerminal/MobileHome/ClassList";
import {
  clickGameLog,
  determinePcOrMove, iconClickEscalation,
  Observer,
  pageInitLog,
  pageOutLog,
  recentGame,
  shuffle
} from '@/utils/utils.js'
export default {
  name: "mobileClassifyIndex",
  components: {
    BottomList, ClassList, MobileLogo
  },
  data() {
    return {
      gameList: [],
      recommend: [],
      gameType: "", // title
      eZzVdABef: 'eZzVdABef',
      clientWidth: 0, // 屏幕宽度
      smegmaType: false,
      contentType: false,
      typeAdv: false,
      caPub: null,
      slot: null,
      allGameList: []
    }
  },
  created() {
    let channelInfo = localStorage.getItem('channelInfo') && JSON.parse(localStorage.getItem('channelInfo'))
    const { m_type_slot, channel_ca_pub } = channelInfo || {}
    this.slot = m_type_slot
    this.caPub = channel_ca_pub
  },
  mounted() {
    const { query } = this.$route
    const { gameType } = query || {}
    if (determinePcOrMove() == 2) {
      let { channel } = this.$route.query
      this.$router.push({
        path: '/P/gameType',
        query: {
          gameType,
          channel
        }
      },()=>{})
    } else {
      setTimeout(()=>{
        window.addAds()
        let innerHtml = document.getElementById('typeAdv') && document.getElementById('typeAdv').innerHTML
        if (innerHtml) {
          this.typeAdv = true
        } else {
          this.typeAdv = false
        }
      },1300)
      this.smegmaType = true
      // 进入页面埋点
      pageInitLog('mobile_tab')
      this.timer = setInterval(()=>{
        if (window.loadOk) {
          clearInterval(this.timer)
          this.smegmaType = false
          this.contentType = true
          window.onresize = () => {
            this.clientWidth = document.body.clientWidth
            this.getGameList()
          }
          this.clientWidth = document.body.clientWidth
          this.getGameList()
          let arr = []
          getAllJson().map((item)=>{
            arr.push(item)
          })
          this.recommend = shuffle(arr).splice(0,30)
          // 获取需要曝光的item
          setTimeout(()=>{
            let itemArr = [...document.getElementsByClassName("sc-wr3rvk-0")]
            itemArr && Array.from(itemArr).map((item)=>{
              Observer('mobile_tab').observe(item)
            })
          })
        }
      },800)
    }
  },
  methods: {
    getGameList() {
      const { query } = this.$route
      const { gameType } = query || {}
      this.gameType = gameType
      let gameArr = getAllJson()
      let gameList = []
      let allGameList = []
      gameArr && gameArr.map((item)=>{
        if (item[gameType] == 1) {
          gameList.push(item)
          allGameList.push(item)
        } else {
          if (gameList.length <= 35) {
            gameList.push(item)
            allGameList.push(item)
          }
        }
      })
      this.allGameList = allGameList
      if (this.clientWidth < 550.9) {
        let newArr = [] // 新数组
        let num = Math.ceil(gameList.length / 12)
        for ( let i = 1; i <= num; i++ ) {
          newArr[i - 1] = gameList.splice(0,12)
        }
        this.gameList = newArr
      } else {
        this.gameList = gameList
      }
    },
    // 切换游戏
    iconClick (item) {
      // 打点
      clickGameLog('mobile_tab', item)
      // 离开页面埋点
      pageOutLog('mobile_tab')
      recentGame(item)
      if (this.$originCopyWriting == 'ajoy') {
        bge && bge('event', 'button', {configId: '903985143796275456'});
        sessionStorage.setItem('pixelType','1')
      }

      iconClickEscalation()
    },
  },
  // beforeRouteLeave(to, from, next){
  //   console.log(to);
  //   console.log(from);
  //   if (to.query.gameId) {
  //     getAllJson().map((item)=>{
  //       if (item.gameId == to.query.gameId) {
  //         // 打点
  //         clickGameLog('mobile_tab', item)
  //         recentGame(item)
  //         if (this.$originCopyWriting == 'ajoy') {
  //           bge && bge('event', 'button', {configId: '903985143796275456'});
  //           sessionStorage.setItem('pixelType','1')
  //         }
  //       }
  //     })
  //   }
  //   next()
  // },
  beforeDestroy() {
    // 离开页面埋点
    pageOutLog('mobile_tab')
  },
  watch: {
    '$route'(val) {
      console.log(val,'数据更新了');
      document.getElementById('mobile_classify').scrollTop = 0
      this.getGameList()
      let arr = []
      getAllJson().map((item)=>{
        arr.push(item)
      })
      this.recommend = shuffle(arr).splice(0,30)
    }
  }
}
</script>

<style lang="less" scoped>
@media (hover: hover){
  .cOWZsC:hover {
    transform: scale(1.01869) translate(0px, -4px)!important;
  }
  .cOWZsC:hover::after {
    opacity: 1!important;
    background: linear-gradient(transparent 50%, rgba(0, 0, 0, 0.3) 100%)!important;
  }
  .cOWZsC:hover .sc-963fcq-0 {
    opacity: 1!important;
    transform: translate(0px, 0px)!important;
  }
}
@media (min-width: 111px) and (max-width: 550.9px) {
  .eZzVdA, .eZzVdA2, .bottom {
    width: 314px;
  }
  .cTVRlj {
    grid-template-areas:
          ". ibx ibx"
          ". bigIp0 bigIp0"
          ". bigIp0 bigIp0"
          ". . ."
          "bigIp6 bigIp6 ."
          "bigIp6 bigIp6 ."
  }
  .cTVRlj3 {
    grid-template-areas:
          ". ibx ibx"
          ". bigIp0 bigIp0"
          ". bigIp0 bigIp0"
          "adv adv adv"
          "adv adv adv"
          "adv adv adv"
          ". . ."
          "bigIp6 bigIp6 ."
          "bigIp6 bigIp6 ."
  }
  .cTVRlj2 {
    grid-template-areas:
          ". ibx ibx"
          ". . ."
  }
}
@media (min-width: 551px) and (max-width: 660.9px) {
  .eZzVdA, .eZzVdA2, .bottom {
    width: 534px;
  }
  .cTVRlj {
    --gridTemplateColumns: 5!important;
    grid-template-areas:
        ". ibx ibx bigIp0 bigIp0"
        ". . . bigIp0 bigIp0"
        "bigIp1 bigIp1 . . ."
        "bigIp1 bigIp1 . . ."
  }
  .cTVRlj3 {
    --gridTemplateColumns: 5!important;
    grid-template-areas:
        ". ibx ibx bigIp0 bigIp0"
        ". . . bigIp0 bigIp0"
        "bigIp1 bigIp1 . . ."
        "bigIp1 bigIp1 . . ."
        "adv adv adv adv adv"
        "adv adv adv adv adv"
        "adv adv adv adv adv"
  }
  .cTVRlj2 {
    --gridTemplateColumns: 5!important;
    grid-template-areas:
          ". ibx ibx . ."
          ". . . . ."
  }
}
@media (min-width: 661px) and (max-width: 880.9px) {
  .eZzVdA, .eZzVdA2, .bottom {
    width: 644px;
  }
  .cTVRlj {
    --gridTemplateColumns: 6!important;
    grid-template-areas:
        ". ibx ibx . bigIp0 bigIp0"
        "bigIp1 bigIp1 . . bigIp0 bigIp0"
        "bigIp1 bigIp1 . . . ."
  }
  .cTVRlj3 {
    --gridTemplateColumns: 6!important;
    grid-template-areas:
        ". ibx ibx . bigIp0 bigIp0"
        "bigIp1 bigIp1 . . bigIp0 bigIp0"
        "bigIp1 bigIp1 . . . ."
        "adv adv adv adv adv adv"
        "adv adv adv adv adv adv"
        "adv adv adv adv adv adv"
  }
  .cTVRlj2 {
    --gridTemplateColumns: 6!important;
    grid-template-areas:
          ". ibx ibx . . ."
          ". . . . . ."
  }
}
@media (min-width: 881px) {
  .eZzVdA, .eZzVdA2, .bottom {
    width: 864px;
    .cTVRlj {
      --gridTemplateColumns: 8!important;
      grid-template-areas:
        ". ibx ibx . . . bigIp0 bigIp0"
        "bigIp1 bigIp1 . . . . bigIp0 bigIp0"
        "bigIp1 bigIp1 . . . . . ."
    }
    .cTVRlj3 {
      --gridTemplateColumns: 8!important;
      grid-template-areas:
        ". ibx ibx . . . bigIp0 bigIp0"
        "bigIp1 bigIp1 . . . . bigIp0 bigIp0"
        "bigIp1 bigIp1 . . . . . ."
        "adv adv adv adv adv adv adv adv"
        "adv adv adv adv adv adv adv adv"
        "adv adv adv adv adv adv adv adv"
    }
    .cTVRlj2 {
      --gridTemplateColumns: 8!important;
      grid-template-areas:
          ". ibx ibx . . . . ."
          ". . . . . . . ."
    }
  }
}
#mobile_classify{
  width: 100%;
  height: auto;
  .game-name{
    background: white;
    border-radius: 16px;
    padding: 10px 16px;
    box-sizing: border-box;
    h1{
      font: 500 20px/24px Torus, sans-serif;
      color: #002b50;
      margin: 0px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    display: flex;
    justify-content: center;
    flex-direction: column;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 6px 12px 0px;
    align-items: center;
    font-size: 21px;
  }
  .content{
    .eZzVdA, .eZzVdA2{
      margin: 0px auto;
      flex-grow: 1;
    }
    .eZzVdABef .cTVRlj::before{
      content: "";
      display: block;
    }
    .eZzVdABef .cTVRlj3::before{
      content: "";
      display: block;
    }
    .eZzVdA2 .cTVRlj2::before{
      content: "";
      display: block;
    }
    .cTVRlj, .cTVRlj2, .cTVRlj3 {
      display: grid;
      grid-template-rows: repeat(auto-fill, 94px);
      grid-gap: 16px;
      grid-auto-flow: dense;
      justify-content: center;
      margin: 16px auto 0px;
      padding: 0px;
      list-style-type: none;
      --gridTemplateColumns: 3;
      grid-template-columns: repeat(var(--gridTemplateColumns),94px);
    }
    .eoBBYj {
      display: block;
      --minSize: 94px;
      min-width: var(--minSize);
      min-height: var(--minSize);
      border-radius: inherit;
      aspect-ratio: 1 / 1;
    }
    .global-cq {
      container-type: inline-size;
      container-name: tilecq;
    }
    .cOWZsC {
      box-shadow: rgba(0, 0, 0, 0.24) 0px 6px 12px 0px;
      user-select: none;
      aspect-ratio: 1 / 1;
    }
    .cASSfo {
      display: block;
      transition: transform .6s cubic-bezier(.25, .1, .25, 1);
      border-radius: 16px;
      position: relative;
    }
    .cASSfo:hover {
      transform: scale(1.04255) translate(0px, -4px);
      transition-duration: 0.3s;
    }
    .cASSfo::after {
      content: "";
      opacity: 0;
      position: absolute;
      left: 0px;
      bottom: 0px;
      width: 100%;
      height: 100%;
      background: linear-gradient(transparent 25%, rgba(0, 0, 0, 0.3) 100%);
      z-index: 4;
      transition: box-shadow .6s cubic-bezier(.25, .1, .25, 1),opacity .3s cubic-bezier(.25, .1, .25, 1);
      box-shadow: rgba(0, 0, 0, 0.24) 0px 6px 12px 0px;
      border-radius: 16px;
      contain: strict;
    }
    .esaxGV {
      position: absolute;
      right: 0px;
      bottom: 0px;
      left: 0px;
      padding: 6px;
      color: rgb(255, 255, 255);
      font: 700 var(--tileFontSize,12px)/1.3 'Proxima Nova',sans-serif;
      text-align: center;
      z-index: 6;
      transition: transform .3s cubic-bezier(.25, .1, .25, 1) .1s,opacity .3s cubic-bezier(.25, .1, .25, 1) .1s;
      transform: translate(0px, 8px);
      opacity: 0;
      -webkit-font-smoothing: antialiased;
      pointer-events: none;
      word-break: break-all;
    }
  }
  .bottom{
    margin: 32px auto 0;
    .bottom-text {
      position: relative;
      margin: 30px 0;
      padding: 18px 24px;
      background: rgb(255, 255, 255);
      box-shadow: rgba(0, 0, 0, 0.24) 0px 6px 12px 0px;
      h1{
        font: 500 24px Torus,sans-serif;
      }
      p{
        margin: 24px 0;
        font: 400 16px/24px Proxima Nova,Open Sans,Gill Sans MT,Gill Sans,Arial,sans-serif;
        color: #002b50;
      }
      a{
        color: #054a91;
        text-decoration: underline;
      }
      h3{
        color: #002b50;
        display: block;
        font-size: 1.17em;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
      }
      h4{
        margin-top: 10px;
        color: #002b50;
      }
      ul,ol{
        padding-left: 40px;
        li{
          margin-bottom: 5px;
          color: #002b50;
          font-size: 16px;
        }
      }
      .about{
        color: #002b50;
        font-size: 9px;
        font-weight: 700;
        letter-spacing: 1px;
        margin: 3px 0 0;
        text-transform: uppercase;
        ul{
          list-style: none;
          margin: 0;
          overflow: hidden;
          padding: 0;
          text-overflow: ellipsis;
          li{
            display: inline;
            font-size: 9px;
            a{
              font-size: 9px;
              letter-spacing: 1px;
              text-transform: uppercase;
              white-space: nowrap;
              color: #002b50;
              text-decoration: none;
            }
          }
          li:nth-child(2)::before{
            content: "›";
            font-size: 13px;
            margin: 0 4px;
          }
        }
      }
      .title{
        font-size: 20px;
        color: #002b50;
        margin-top: 10px;
        h2{
          font: 500 20px Torus,sans-serif;
        }
      }
    }
  }
  @keyframes djqRmU{
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.8;
    }
  }
  @keyframes etkMLf{
    0%, 80%, 100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
  .dgmlwU{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    animation: djqRmU .2s cubic-bezier(.25, .1, .25, 1) both;
    z-index: 100001;
  }
  .AFSJx{
    display: flex;
    align-items: center;
    justify-content: center;
    div{
      width: 18px;
      height: 18px;
      margin: 0 2px;
      border-radius: 100%;
      background: #FC8F47;
      animation: 1.4s ease-in-out 0s infinite normal both running etkMLf;
    }
    div:nth-child(2){
      animation-delay: -0.16s;
    }
  }
}
</style>
